import { Box, Button, Heading, Text, VStack, useToast } from "@chakra-ui/react";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { useForm } from "react-hook-form";
import { issbKeys } from "hooks/query";
import { showErrorToast } from "utils";
import useAirUserRoles from "../../../../utils/AuthUtils";
import Issb from "api/issb/issb";
import FormSelectUser from "../../FormSelectUser";
import SecondaryHeader from "../../components/SecondaryHeader";

export default function FoundationSetupController({ foundationRound }) {
  const { isOrgAdmin } = useAirUserRoles();
  const queryClient = useQueryClient();
  const toast = useToast();
  const [saving, setSaving] = useState(false);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    const ownerEmails = data._owners.map((o) => o.value);
    setSaving(true);
    try {
      await Issb.setFoundationControllers(ownerEmails);
      queryClient.invalidateQueries(issbKeys.questionnaireRound());
    } catch (err) {
      showErrorToast(toast, err.response?.data?.parameters?.message ?? err.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <SecondaryHeader showRoundSelector={false} showActions={false}>
      <Box px={4} py={20}>
        <VStack spacing={6} maxW="500px" mx="auto">
          {isOrgAdmin ? (
            <>
              <Heading fontSize="heading.l" color="darkTeal" textAlign="center">
                Set up Foundation Data
              </Heading>
              <Text color="gray.600" textAlign="center">
                Assign a controller to manage the Foundation Data round. The controller will be able to manage
                questions, assign owners, and oversee the data collection process.
              </Text>
              <Box w="100%">
                <FormSelectUser
                  label="Controllers"
                  name="_owners"
                  control={control}
                  rules={{ required: "A Controller is required" }}
                  size="lg"
                  errors={errors}
                  menuPortalTarget={document.body}
                />
              </Box>
              <Button
                w="100%"
                variant="darkTeal"
                isLoading={saving}
                onClick={handleSubmit(onSubmit)}
              >
                Save and Continue
              </Button>
            </>
          ) : (
            <>
              <Heading fontSize="heading.l" color="darkTeal" textAlign="center">
                Foundation Data Setup Required
              </Heading>
              <Text color="gray.600" textAlign="center">
                Contact your organization admin to complete the Foundation Data setup.
              </Text>
            </>
          )}
        </VStack>
      </Box>
    </SecondaryHeader>
  );
}
